import request from '@/utils/request'

// 新建礼品订单
export function giftAdd(data) {
  return request({
    url:'/Crm.Gift/gift_add',
    method:'post',
    data:data
  })
}
// 修改礼品单表头
export function giftUpdate(data) {
  return request({
    url:'/Crm.Gift/gift_update',
    method:'post',
    data:data
  })
}

// 删除礼品订单
export function giftDelete(data) {
  return request({
    url:'/Crm.Gift/gift_delete',
    method:'post',
    data:data
  })
}

// 查看礼品订单详情
export function giftView(params) {
  return request({
    url:'/Crm.Gift/gift_view',
    method:'get',
    params:params
  })
}

// 礼品订单列表
export function giftList(params) {
  return request({
    url:'/Crm.Gift/gift_list',
    method:'get',
    params:params
  })
}

// 删除礼品订单行项目
export function giftLineDelete(data) {
  return request({
    url:'/Crm.Gift/gift_line_delete',
    method:'post',
    data:data
  })
}

// 修改礼品订单行项目
export function giftItemsUpdate(data) {
  return request({
    url:'/Crm.Gift/giftItemsUpdate',
    method:'post',
    data:data
  })
}

// 礼品订单行项目添加
export function orderLineAdd(data) {
  return request({
    url:'/Crm.Gift/order_line_add',
    method:'post',
    data:data
  })
}

// 礼品订单审核
export function giftVerify(data) {
  return request({
    url:'/Crm.Gift/giftVerify',
    method:'post',
    data:data
  })
}

// 礼品订单返审核
export function giftDeaudit(data) {
  return request({
    url:'/Crm.Gift/giftDeaudit',
    method:'post',
    data:data
  })
}
// 获取礼品单信息
export function giftListTips(params) {
  return request({
    url:'/Crm.Gift/giftListTips',
    method:'get',
    params:params
  })
}



// WEBPACK FOOTER //
// ./src/api/gift.js